/********************************************
* Home hero
*
* Slick Slider
* http://kenwheeler.github.io/slick/
********************************************/
function fnHomeHero( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection					= $( oSection ),
		oCarousel					= $( '.slick-slider', oSection );

	/*****************
	* Carousel configuration
	*****************/
	oCarousel.slick({
  		lazyLoad: 					'ondemand',
		touchThreshold:   	 		20,
		autoplay:   	      		true,
		autoplaySpeed:   	      	5000,
		dots:   	          		true,
		arrows:   	        		false,
		infinite:   	        	true,
		slidesToShow: 				1,
		speed:   	         		500,
		variableWidth:				false,
		adaptiveHeight:   			false,
		mobileFirst:   	   			true,
		focusOnSelect:   	 		false
	});

}


// END OF DOCUMENT
